/**
 * Shared type for CSS class values, compatible with clx/clsx.
 * Defined here to avoid duplicating across component files and to stay
 * decoupled from the clsx package version (which differs between our
 * direct dependency and the one bundled in @medusajs/ui).
 */
export type ClassValue = string | number | boolean | null | undefined | ClassValue[] | Record<string, unknown>;

/**
 * Return a shallow copy of `obj` with every key in `keys` removed.
 *
 * Useful for components with discriminated-union props where TypeScript
 * does not allow rest-spread destructuring across union branches.
 */
export function omitKeys<T extends Record<string, unknown>, K extends string>(
  obj: T,
  keys: ReadonlySet<K>,
): Omit<T, K> {
  const result = {} as Record<string, unknown>;
  for (const key of Object.keys(obj)) {
    if (!keys.has(key as K)) {
      result[key] = obj[key];
    }
  }
  return result as Omit<T, K>;
}
